module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback7-d3f24e732471503294395b0b5a089284.jpg";